import { parseJsonIfValid } from 'rcx_adapter/src/util';
import i18n from 'rcx_i18n';

import type { RingCXCall, SNLogData, SNLogOptions, RingCXChat } from '../../interfaces';
import { removeEmptyValues } from '../../utils/misc';
import { getTimestamp, setUTCTime } from '../../utils/timeFormat';

export function generatePatchData({
    selectedName,
    selectedRelatedTo,
    disposition,
    notes,
    duration,
    recordingUrl,
    transcriptUrl,
    subject,
    handleTime,
    summary,
    leadName,
    isEnded,
}: SNLogOptions): Partial<SNLogData> {
    return removeEmptyValues({
        whoId: selectedName?.id,
        whoType: selectedName?.type,
        whatId: selectedRelatedTo?.id,
        whatType: selectedRelatedTo?.type,
        callDurationInSeconds: duration ? Number.parseInt(duration) : undefined,
        RCX_Disposition: disposition,
        description: notes,
        Call_Recording: recordingUrl,
        Call_Transcript: transcriptUrl,
        subject,
        Call_HandleTime: handleTime ? getTimestamp(handleTime) : null,
        summary,
        leadName,
        isEnded,
    });
}

export function generateCallData(call: RingCXCall): Partial<SNLogData> {
    let logFields = call.sessionData?.cx?.crm?.logFields;
    if (!logFields && call?.sessionData) {
        logFields = parseJsonIfValid(call.sessionData)?.cx?.crm?.logFields;
    }
    return {
        type: 'phone',
        activityDate: call.queueTimestamp ? setUTCTime(call.queueTimestamp) : 0,
        callType: call.callType?.toLowerCase(),
        Call_UUID: call.uii,
        Call_Queue: call?.queue?.name || '',
        Call_HandleTime: call.queueTimestamp,
        phone: call.aniE164 || call.ani || '',
        logFields: logFields,
    };
}

export function generateChatData(chat: RingCXChat): Partial<SNLogData> {
    return {
        taskSubtype: chat.channelType?.toUpperCase() === 'EMAIL' ? 'Email' : 'Task',
        activityDate: setUTCTime(chat.lastMsgDts),
        Call_UUID: chat.uii,
        Call_Queue: chat.chatQueueName || '',
        RCX_Digital_Type: i18n.t('digital.type_inbound', {
            channelType: i18n.t(`digital_channels.${chat.channelType?.toUpperCase()}`),
        }),
        RCX_UUID: chat.edUuid,
        channelType: chat.channelType,
        type: 'messaging',
    };
}
